<div
  class="message"
  [ngClass]="{
    'message--host': isHost,
    '!mt-0': messageIndex() === 0,
  }">
  <!-- profile -->
  @if (!isHost) {
    <div class="message__profile">
      <img
        class="profile-img"
        [ngSrc]="
          messageData()?.picture?.cropped_url
            | imageSource: false : 'sm' : 'assets/images/no-profile-image.png'
        "
        [alt]=""
        width="32"
        height="32" />
    </div>
  }

  <!-- message content -->
  <div class="message__content">
    <p class="message-text">
      {{
        isTranslateMode && translateLang ? messageData()?.message?.[translateLang] : messageData()?.message?.[currentLang]
      }}
    </p>

    <!-- message details -->
    <div class="message-details">
      <!-- message time -->
      <span class="message-details__time">
        {{ messageData()?.created_at | date: 'shortTime' }}
      </span>
      <!-- message delivery state -->
      <span class="message-details__delivery-state">
        @if (isHost) {
          @if (messageData()?.is_message_posted) {
            <!-- tick icon -->
            <span class="message-details__tick-icon">✓</span>
          } @else {
            <!-- clock icon -->
            <span class="message-details__clock-icon"
              ><i class="iconsax" icon-name="clock"></i
            ></span>
          }
        }
      </span>
    </div>
  </div>

  @if (!isHost && translateLang) {
    <!-- translate button -->
    <button class="message__translate-btn" (click)="toggleTranslateMessage()">
      {{
        (isTranslateMode ? 'chat.seeTranslation' : 'chat.seeOriginalMessage')
          | translate
      }}
    </button>
  }
</div>
